var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "list-view-page",
      class: { "header-page-long": !_vm.is_sidebar_minimized }
    },
    [
      _c("div", { staticClass: "section-list" }, [
        _c(
          "div",
          { staticClass: "list-view" },
          _vm._l(_vm.sectionGeneral, function(item) {
            return _c(
              "div",
              {
                key: item.id,
                staticClass: "card-view",
                class: { "card-active": _vm.menuActive === item.id },
                on: {
                  click: function($event) {
                    _vm.changeView(item.id)
                  }
                }
              },
              [
                _vm.formDetail.name &&
                _vm.menuActive === item.id &&
                !_vm.changes_value_view
                  ? _c("img", {
                      staticClass: "icon-checked",
                      attrs: {
                        src: require("@/assets/new-form-ui/icon-active/check-circle-active.svg")
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.formDetail.name &&
                _vm.menuActive !== item.id &&
                !_vm.changes_value_view
                  ? _c("img", {
                      staticClass: "icon-checked",
                      attrs: {
                        src: require("@/assets/new-form-ui/icon/check-circle.svg")
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.menuActive === item.id && _vm.changes_value_view
                  ? _c("img", {
                      staticClass: "icon-checked",
                      attrs: {
                        src: require("@/assets/new-form-ui/editable.svg")
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.formDetail.name &&
                _vm.menuActive !== item.id &&
                _vm.changes_value_view
                  ? _c("img", {
                      staticClass: "icon-checked",
                      attrs: {
                        src: require("@/assets/new-form-ui/icon/check-circle.svg")
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.menuActive === item.id
                  ? _c("img", {
                      staticClass: "icon-view",
                      attrs: {
                        src: require("@/assets/new-form-ui/icon-active/" +
                          item.icon +
                          ".svg")
                      }
                    })
                  : _c("img", {
                      staticClass: "icon-view",
                      attrs: {
                        src: require("@/assets/new-form-ui/icon/" +
                          item.icon +
                          ".svg")
                      }
                    }),
                _vm._v(" "),
                _c("span", [
                  _vm._v("\n          " + _vm._s(item.name) + "\n        ")
                ])
              ]
            )
          })
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "line" }),
      _vm._v(" "),
      _c("div", { staticClass: "section-list" }, [
        _c(
          "div",
          { staticClass: "list-view" },
          _vm._l(_vm.sectionView, function(item) {
            return _c(
              "div",
              {
                key: item.id,
                staticClass: "card-view",
                class: {
                  "mr-4": item.id === "calendar" || item.id === "detail",
                  "card-active": _vm.menuActive === item.id,
                  disabled: !_vm.formDetail.type
                },
                on: {
                  click: function($event) {
                    _vm.changeView(item.id)
                  }
                }
              },
              [
                _vm.formDetail[item.key] &&
                _vm.menuActive === item.id &&
                !_vm.changes_value_view
                  ? _c("img", {
                      staticClass: "icon-checked",
                      attrs: {
                        src: require("@/assets/new-form-ui/icon-active/check-circle-active.svg")
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.formDetail[item.key] &&
                _vm.menuActive !== item.id &&
                !_vm.changes_value_view
                  ? _c("img", {
                      staticClass: "icon-checked",
                      attrs: {
                        src: require("@/assets/new-form-ui/icon/check-circle.svg")
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.menuActive === item.id && _vm.changes_value_view
                  ? _c("img", {
                      staticClass: "icon-checked",
                      attrs: {
                        src: require("@/assets/new-form-ui/editable.svg")
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.formDetail[item.key] &&
                _vm.menuActive !== item.id &&
                _vm.changes_value_view
                  ? _c("img", {
                      staticClass: "icon-checked",
                      attrs: {
                        src: require("@/assets/new-form-ui/icon/check-circle.svg")
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.menuActive === item.id
                  ? _c("img", {
                      staticClass: "icon-view",
                      attrs: {
                        src: require("@/assets/new-form-ui/icon-active/" +
                          item.icon +
                          ".svg")
                      }
                    })
                  : _c("img", {
                      staticClass: "icon-view",
                      attrs: {
                        src: require("@/assets/new-form-ui/icon/" +
                          item.icon +
                          ".svg")
                      }
                    }),
                _vm._v(" "),
                _c("span", [
                  _vm._v("\n          " + _vm._s(item.name) + "\n        ")
                ])
              ]
            )
          })
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4ec716f4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ec716f4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/experience-manager-v2/partials/ListView.vue
// module id = null
// module chunks = 